import {refreshSvg as Icon__small__refreshSvg} from '../Icon__small/Icon__small--refresh.js';

export var refresh = {
  name: 'refresh',
  category: 'icon',
  colorable: true,
  svg: Icon__small__refreshSvg,
};
